// @flow
import OrgsListTableCellLinks from './OrgsListTableCellLinks';
import getLinksData from './getLinksData';

export default OrgsListTableCellLinks;
export { getLinksData };
